export const INDEXER_ENDPOINT = 'https://jsonrpc.indexer.haqq.network';
export const WALLETCONNECT_PROJECT_ID = process.env['WALLETCONNECT_PROJECT_ID'];
export const GIT_COMMIT_SHA = process.env['GIT_COMMIT_SHA'];
export const POSTHOG_KEY = process.env['POSTHOG_KEY'];
export const POSTHOG_HOST = process.env['POSTHOG_HOST'];
export const isDev = process.env['NODE_ENV'] !== 'production';
